//components
import { Accordion, Badge } from '@bosch/react-frok'
import { MessageSource } from './MessageSource'

//types
import type { MessageSourceGroupProps } from './types/MessageSourceGroupTypes'

import './MessageSourceGroup.scss'

export const MessageSourceGroup = ({
	groupKey,
	sources,
	config,
}: MessageSourceGroupProps) => {
	const shouldShowBadge = sources.length > 1
	const firstSource = sources[0]
	const headline = firstSource?.cluster_key === 'line'
		? firstSource.line || 'N/A'
		: firstSource?.cluster_key === 'origin'
			? firstSource.origin || 'N/A'
			: groupKey || 'N/A'

	return (
		<div className="source-group">
			<Accordion
				className="sources-accordion-group"
				size="small"
				headline={
					<div className="source-group-headline">
						<span className="source-group-title">{headline}</span>
						{shouldShowBadge && (
							<Badge label={sources.length} />
						)}
					</div>
				}
			>
				<div className="source-group-content">
					{sources.map((source, index) => (
						<div key={`${groupKey}-${index}`} className="source-group-item">
							<MessageSource
								source={source}
								config={config}
							/>
						</div>
					))}
				</div>
			</Accordion>
		</div>
	)
}

export default MessageSourceGroup
